<template>
	<div class="survey-result-container">
		<Nav />
		<span class="overlay" :class="{active: isMenuOpen}"></span>
		<div class="header header-standard">
			<HeaderNavBar back survey searchType="resources"/>
		</div><!-- header -->
		<div class="sr-hero">
			<img class="survey-ship" alt="The Seafarers Happiness Index" src="@/assets/survey-ship.png" />
			<div class="sr-hero-head">
                <h1>Your Result <span>{{ result.created_at | moment('Do MMMM YYYY') }}</span></h1>
				<img class="shi-logo" alt="The Seafarers Happiness Index" src="@/assets/shi-logo-big.png" />
			</div>
			<div class="sr-hero-blocks">
				<div class="sr-block">
					<span class="block-title">Overall score</span>
					<div class="score-card-total">
						<span class="score-card-result">{{ parseFloat(result.score) }}</span>
						<span class="score-card-total-max">/ 10</span>
					</div>
				</div>
				<div class="sr-block" :class="{ 'red': stats.change < 0 }">
					<span class="block-title">Change since your last result</span>
					<div class="score-card-total with-arrow">
						<UpArrowIcon v-if="stats.change > 0" class="up-arrow" />
                        <DownArrowIcon v-else class="down-arrow" />
						<span class="score-card-result">{{ stats.change ? parseFloat(stats.change).toString().replace('-', '') : 0 }}</span>
					</div>
				</div>
				<div class="sr-block" :class="{ 'red': stats.report < 0 }">
					<span class="block-title">Compared to our Q1 2023 report</span>
					<div class="score-card-total with-arrow">
                        <UpArrowIcon v-if="stats.report > 0" class="up-arrow" />
                        <DownArrowIcon v-else class="down-arrow" />
						<span class="score-card-result">{{ stats.report ? parseFloat(stats.report).toString().replace('-', '') : 0 }}</span>
					</div>
				</div>
				<div class="sr-block" :class="{ 'red': stats.average < 0 }">
					<span class="block-title">Compared to your average result</span>
					<div class="score-card-total with-arrow">
                        <UpArrowIcon v-if="stats.average > 0" class="up-arrow" />
                        <DownArrowIcon v-else class="down-arrow" />
						<span class="score-card-result">{{ stats.average ? parseFloat(stats.average).toString().replace('-', '') : 0 }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="content-wrap content-wrap-alt content-wrap-nav no-border">
			<div class="section-gap none-top">
				<ScoreQuestion
                    v-for="(question, index) in result.data"
                    :key="question.question"
					:question="'Question ' + (index + 1)"
					:title="question.question"
					:type="question.answer ? getMood(question.answer) : null"
                    :score="question.answer ? question.answer : null"
                    :feedback="question.feedback"
				/>
			</div><!-- card wrap -->
			<div class="section-gap card-wrap">
				<Card
					routeName="SurveyTake"
					class="card-block-sky-base"
					icon="SurveyIcon"
					title="Take our Survey"
					text="Lorem ipsum dolor sit amet consectetur"
				/>
				<Card
					routeName="SurveyReports"
					class="card-block-yellow-filled"
					icon="ChartIcon"
					title="View our Reports"
					text="View our quarterly reports"
				/>
			</div><!-- card wrap -->
		</div>
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Menu from '@/components/Menu.vue';
	import Card from '@/components/Card.vue';
    import ScoreQuestion from '@/components/ScoreQuestion.vue';
    import UpArrowIcon from '@/assets/arrow-up.svg';
    import DownArrowIcon from '@/assets/arrow-down.svg';
    import SurveyService from '@/services/SurveyService';
	export default {
		name: 'SurveyResult',
		components: {
			Nav,
			HeaderNavBar,
			Menu,
			Card,
			UpArrowIcon,
			DownArrowIcon,
			ScoreQuestion
		},
		data () {
	        return {
                result: {},
                stats: {}
	        };
	    },
	    methods: {
	    	getResult () {
                return SurveyService.getResult(this.$route.params.id).then((response) => {
                    this.result = response.data.result;
                    this.stats = response.data.stats;
                });
            },
            getMood (answer) {
                if (answer <= 4) {
                    return 'sad';
                }
                if (answer > 4 && answer < 7) {
                    return 'average';
                }
                if (answer >= 7) {
                    return 'happy';
                }
            }
	    },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        }
		},
		mounted () {
            this.getResult();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	@mixin max_width($breakpoint) {
	    @media only screen and (max-width: $breakpoint) { @content; }
	}
	.no-border {
		border-radius: 0;
	}
	.survey-result-container {
		background: $sky_base;
	}
	.sr-hero {
		position: relative;
		text-align: left;
		padding: 0 28px;
		padding-bottom: 140px;
		.survey-ship {
			width: 391px;
		    height: auto;
		    position: absolute;
		    bottom: 0;
		    left: 0;
		    max-width: 95%;
		}
	}
	.sr-hero-head {
		display: flex;
		justify-content: space-between;
		margin-bottom: 25px;
		margin-top: 30px;
		h1 {
			font-size: 24px;
			line-height: 31px;
			color: $white;
			font-weight: 400;
			margin-right: 20px;
			span {
				font-weight: 600;
				display: block;
			}
		}
		img {
			flex-shrink: 0;
		    height: 64px;
		    width: auto;
		    max-width: none;
		}
	}
	.sr-hero-blocks {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.sr-block {
			position: relative;
			border-radius: 12px;
			padding: 12px 15px;
			background: $white;
			width: 47.5%;
			margin-bottom: 5%;
			height: 150px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			.block-title {
				font-size: 17px;
				line-height: 20px;
				font-weight: 600;
				color: #0C9648;
				letter-spacing: -0.5px;
			}
			&.red {
				.block-title {
					color: $red_dark;
				}
				.score-card-total {
					color: $red_dark;
				}
			}
		}
		.up-arrow, .down-arrow {
			width: 18px;
    		margin-right: 5px;
		}
		.score-card-total {
			font-weight: 600;
			color: #0C9648;
			font-size: 36px;
			letter-spacing: -1.06px;
			line-height: 24px;
			margin: 12px 0 0px;
			&.with-arrow {
				display: flex;
				align-items: center;
				padding-bottom: 5px;
			}
			&.red {
				color: $red_base;
			}
			.score-card-total-max {
				font-size: 22px;
				letter-spacing: -0.65px;
				opacity: 0.7;
				margin-left: 6px;
			}
		}
	}
	.has-split {
		display: flex;
		justify-content: space-between;
		align-items: center;
		@include max_width(380px) {
			align-items: flex-start;
		}
		.shi-logo {
			margin-left: 15px;
			@include max_width(380px) {
				width: 85px;
			}
		}
	}
</style>
